<script setup lang="ts">
import { TRANSITION_SOURCE } from '#shared/constant/constant'
import { LOCAL_CAR_CODE, FOREIGN_CAR_CODE } from '@/constant/brandCarParams'

const catalogSearchMakerFlg: Ref<boolean> = useState(
  'catalog_search_maker_flg',
  () => true
)
const generateBrandAssetImagePath = (name: string) => {
  let url = new URL(
    `../../assets/image/brands/logo/${name}.webp`,
    import.meta.url
  ).href
  if (url.endsWith('undefined')) {
    url = new URL(`../../assets/image/brands/logo/0000.webp`, import.meta.url)
      .href
  }
  return url
}
const clickTag = ref(false)

function changeFlg(foreignCarFlg: boolean) {
  if (!clickTag.value) {
    clickTag.value = true
    catalogSearchMakerFlg.value = true
    if (foreignCarFlg) {
      navigateTo({
        path: '/brand-selection',
        query: { query: 'ドイツ' },
      })
    } else {
      navigateTo({
        path: '/brand-selection',
      })
    }
  }
}

function toNextPage(brandCd: number) {
  if (!clickTag.value) {
    clickTag.value = true
    navigateTo({
      path: '/car-model-list',
      query: {
        brand_cd: brandCd,
        transition_source: TRANSITION_SOURCE.catalog_search,
      },
    })
  }
}

onMounted(() => {
  clickTag.value = false
})
</script>

<template>
  <div class="item-brand-car">
    <div v-for="x in (LOCAL_CAR_CODE.length / 5) | 0" :key="x" class="row">
      <div v-for="i in 5" :key="i" class="car-logo">
        <div
          v-if="x !== LOCAL_CAR_CODE.length / 5 || i !== 5"
          @click="toNextPage(LOCAL_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_cd)"
        >
          <a data-wpel-link="internal">
            <div class="icon-area" :class="[x === 1 ? 'first-line' : '']">
              <img
                :src="
                  generateBrandAssetImagePath(
                    String(LOCAL_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_cd)
                  )
                "
                onerror="
                  this.src =
                    'https://img.goo-net.com/goo/usedcar/nophoto_big.jpg'
                "
              />
            </div>
          </a>
        </div>
        <div v-if="x !== LOCAL_CAR_CODE.length / 5 || i !== 5" class="name">
          {{ LOCAL_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_name }}
        </div>
        <div v-else @click="changeFlg(false)">
          <div class="viewMore">
            <div>国産車<br />すべて</div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="x in (FOREIGN_CAR_CODE.length / 5) | 0" :key="x" class="row">
      <div v-for="i in 5" :key="i" class="car-logo">
        <div
          v-if="x !== FOREIGN_CAR_CODE.length / 5 || i !== 5"
          @click="toNextPage(FOREIGN_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_cd)"
        >
          <a data-wpel-link="internal">
            <div
              class="icon-area"
              :class="[
                FOREIGN_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_cd === 2025
                  ? 'black-area'
                  : '',
              ]"
            >
              <img
                :src="
                  generateBrandAssetImagePath(
                    String(FOREIGN_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_cd)
                  )
                "
                onerror="
                  this.src =
                    'https://img.goo-net.com/goo/usedcar/nophoto_big.jpg'
                "
              />
            </div>
          </a>
        </div>
        <div v-if="x !== FOREIGN_CAR_CODE.length / 5 || i !== 5" class="name">
          {{ FOREIGN_CAR_CODE[i + (x - 1) * 5 - 1]!.brand_name }}
        </div>
        <div v-else @click="changeFlg(true)">
          <div class="viewMore">
            <div>輸入車<br />すべて</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.item-brand-car {
  background-color: #ffffff;
  width: 100%;
}

.row {
  --bs-gutter-x: 0;
}

a {
  width: 56px;
}

.icon-area {
  width: 56px;
  height: 56px;
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  box-shadow: 1px 1px 1px #0000001a;
}

.black-area {
  background-color: black;
}

.car-logo {
  width: 56px;
  margin: 0 auto;
}

.first-line {
  margin-top: 21px;
}

.car-logo img {
  width: 56px;
  height: 56px;
  display: block;
  padding: 6px;
}

.car-logo .name {
  font-size: 11px;
  font-weight: bold;
  width: 56px;
  text-align: center;
  margin-bottom: 12px;
  color: #333333;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  white-space: pre-wrap;
}

.car-logo .viewMore {
  width: 56px;
  height: 56px;
  border-radius: 10px;
  display: block;
  box-shadow: 1px 1px 1px #0000001a;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
  float: right;
  color: #000000e5;
  align-items: center;
}

.viewMore div {
  margin-top: 15px;
}

.viewMore i {
  font-size: 15px;
  color: red;
  margin-left: 3px;
}
</style>
